import "bootstrap/dist/css/bootstrap.min.css";
import "../../App.scss";
import "../../style2.scss";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Footer from "./Footer";
import Header from "./Header";
import SubHeader2 from "./SubHeader2";
import { useLocation, useNavigate } from "react-router-dom";
import {O2FORM} from "constants/route";
import { Modal } from "react-bootstrap";

const log = (...args) => {
  console.log("idle", ...args);
}

const TimeoutModal = ({ show, logout, continueSession }) => {
  const isMobile = window.innerWidth < 768;

  return <Modal show={show}>
      <Modal.Header className="bg-button-color" closeButton={false} />
      <Modal.Body className="p-3">
              {/* <div className={"text-center"}>
                <i
                  className={`icon-dls-warning-solid icon-big`}
                  style={{ color: "#a46200", fontSize: 80 }}
                  aria-hidden="true"></i>
                {error}
              </div> */}
        <div className="cmp-modal__content text-center" style={{color:"#134f4e"}} >
          <div className="cmp-modal__icon">
            <span className="icon-dls-warning-solid"
                      style={{ color: "#b7760d", fontSize: 80 }}
            ></span>
          </div>
          <div>
            <h4 className="title__text title__text--semi-bold" style={{paddingBottom: 16}}>
              Your session is about to time out.
            </h4>
            <p className="cmp-modal__content--cta" style={{fontWeight:600}}>
              You have been inactive for a while. Would you like to log out or continue?
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <div className="cmp-modal__cta logout-button-layout-mobile">
          <button className="cmp-button cmp-button--secondary cmp-button--cancel" onClick={logout}>
            <span className="cmp-button__text"> Log out </span>
          </button>
          { !isMobile ? <>&nbsp;&nbsp;&nbsp;</> : <></> }
          <button className="cmp-button cmp-button--primary cmp-button--ok" onClick={continueSession}>
            <span className="cmp-button__text"> Continue </span>
          </button>
        </div>
     </Modal.Footer>
   </Modal>
}

// let _timeout;
// let _timeoutWarning;
// const useIdleTimeout = ({idleExpirySec,idleExpiryWarningSec, onWarning, onTimeout}) => {
//     // log("useIdleTimeout init", {idleExpirySec,idleExpiryWarningSec});
//     const _clearTimeout = () => {
//       log("_clearTimeout");
//       if (_timeout) {
//         clearTimeout(_timeout);
//         _timeout = null;
//       }
//       if (_timeoutWarning) {
//         clearTimeout(_timeoutWarning);
//         _timeoutWarning = null;
//       }
//     }

//     const _startTimeout = () => {
//       log("_startTimeout");
//       _timeout = setTimeout(() => {
//         log("timeout");
//         onTimeout && onTimeout();
//       }, idleExpirySec);
//     }

//     const _startWarning = () => {
//       log("_startWarning");
//       _timeoutWarning = setTimeout(() => {
//         log("warning");
//         onWarning && onWarning();
//       }, idleExpiryWarningSec);
//     }

//     return {
//       startIdleTimer: () => {
//         log("startIdleTimer");
//         _clearTimeout();
//         _startTimeout();
//         _startWarning();
//       },
//       stopIdleTimer: () => {
//         log("stopIdleTimer");
//         _clearTimeout();
//       }
//     }
// }

const useIdleTimeout = ({idleExpirySec,idleExpiryWarningSec, onWarning, onTimeout}) => {
    const [_timeout, _setTimeout] = useState(null);
    const [_timeoutWarning, _setTimeoutWarning] = useState(null);
    
    // const [hasChanges, setHasChanges] = useState(false);
    // useEffect(() => {
    // }, [hasChanges]);
 
    useEffect(() => {
      return () => {
        log("cleanup");
        _timeout && clearTimeout(_timeout);
        _timeoutWarning && clearTimeout(_timeoutWarning);
      }
    }, [_timeout, _timeoutWarning]);

    // log("useIdleTimeout init", {idleExpirySec,idleExpiryWarningSec});
    const _clearTimeout = () => {
      log("_clearTimeout");
      if (_timeout) {
        clearTimeout(_timeout);
        _setTimeout(null);
      }
      if (_timeoutWarning) {
        clearTimeout(_timeoutWarning);
        _setTimeoutWarning(null);
      }
    }

    const _startTimeout = () => {
      log("_startTimeout");
      _setTimeout(setTimeout(() => {
        log("timeout");
        onTimeout && onTimeout();
      }, idleExpirySec));
    }

    const _startWarning = () => {
      log("_startWarning");
      _setTimeoutWarning(setTimeout(() => {
        log("warning");
        onWarning && onWarning();
      }, idleExpiryWarningSec));
    }

    return {
      startIdleTimer: () => {
        log("startIdleTimer");
        _clearTimeout();
        _startTimeout();
        _startWarning();
      },
      stopIdleTimer: () => {
        log("stopIdleTimer");
        _clearTimeout();
      }
    }
}


export default function Layout(props) {

  const [showIdleTimeoutModal, setShowIdleTimeoutModal] = React.useState(false);
  const { isLogin } = useSelector((state) => state.signPassIdentify);

  const {
    subHeader = null,
    mainText = null,
    loginRequired = true,
    noSubHeaderMainText = false
  } = props;

  const { isOpenedSideBar } = useSelector((state) => state.header);
  const { pathname } = useLocation();

  const onIdleWarning = () => {
    setShowIdleTimeoutModal(true);
  }

  const onIdleTimeout = () => {
    setShowIdleTimeoutModal(false);
    idleLogout();
  }
  const { startIdleTimer, stopIdleTimer } = useIdleTimeout({  
    idleExpirySec: window.idleExpirySec, 
    // idleExpirySec: 3 * 60 * 1000,
    idleExpiryWarningSec: window.idleExpiryWarningSec,
    onWarning: onIdleWarning,
    onTimeout: onIdleTimeout,
  });

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(()=>{
     if(pathname === O2FORM) {
       stopIdleTimer();
     } else {
       startIdleTimer();
     }
     return () =>{
       stopIdleTimer();
     }
  }, [pathname]);

  const logout = () => {
    if (window.appMode === "DEV") {
      alert("Please click logout manually. This is a DEV environment.");
      navigate(O2FORM);
    } else {
      // UAT or PROD
      window.location.href = window.mainLogoutUrl;
    }
  };

  // If user is act as clicking logout button.
  // If not, recirect to home, O2FORM
  const idleLogout = () => {
    if (isLogin) {
      logout();
    } else {
      navigate(O2FORM);
    }
  }

  return (
    <>
      <div className="page-main">
        <Header loginRequired={loginRequired} />
          <SubHeader2
            noSubHeaderMainText={noSubHeaderMainText}
            header={subHeader}
            mainText={mainText}
          />
        {!isOpenedSideBar && (
          <>
            <div className={`container-parent`} style={{ paddingBottom: 20 }}>
                <div
                  className={`container wrap-container sm-container-max-width md-container-max-width`}>
                  <div className="row" style={{ paddingBottom: 50 }}>
                    <div className="col-sm-12 my-auto">
                      <div className="mx-auto sm-form-mt md-form-mt lg-form-mt xl-form-mt ">{props.children}</div>
                    </div>
                  </div>
                </div>
            </div>
            <Footer />
          </>
        )}
      </div>
      <TimeoutModal show={showIdleTimeoutModal} 
        logout={onIdleTimeout} 
        continueSession={()=>{
          setShowIdleTimeoutModal(false);
          startIdleTimer();
        }}/> 
    </>
  );
}
